module.exports = __webpack_public_path__ + "static/media/asynch-classroom-welcome.c68ac770.svg";